import React from 'react';

function poem1() {
    return {
        title: "Cross Over the Bridge", text: (
            <pre>{`
See the structure majestic and bold,
Towering high through heat and cold
With sweeping strength to hold secure
Five hundred tons or even more..

The crossing is there, some have begun
But wary the many with songs unsung
Still do they cower from deeds undone
And lose the throb of a challenge won.

The sway is rich for winds do thrust
And gather there in mighty gusts
Yet proudly it stands to welcome all
Though snow, rain, and sleet may fall.

So forge ahead and make brave the day
And find true friendship along the way,
It calls to us with each rising sun
To make each moment a cherished one.

Let’s bridge that gap and be on the mend,
To follow our hearts and perhaps meet a friend
Cross over the bridge and look toward tomorrow,

And love and friendship are sure to follow.
        `}</pre>
        )
    }
}

function poem2() {
    return {
        title: "Petals of Love: A Poem of Gratitude", text: (
            <pre>{`
See the  pretty Orchids of passion and grace
Closely bunched with Hydrangeas for taste,
Suggesting gratefulness and heartfelt sincerity,
And Forget-Me-Not’s for hope and fond memory.
 
The Daisy for Love that conquers all,
As the Mum’s optimism brings long life and joy.
Elderberry and Violets for faithfulness and zeal,
And Lavender Heather for beauty that is real.
   
The promise of Stargazers both beautiful and bold
Midst  enchanting starru asters frpm days of old.
Pink roses for class and refinement I am told
As baby breathe whispers "let new Life unfold." 

And  Fern for leaves of gentle fascination,
As the Sunflower stands in pure adoration
Come Honeysuckle with devoted affection
And Sycamore too with curiosity and attention.
 
All words of kindness and flowers to behold,
Gently speak to our heart and soul,
For they keep us in unity with loved ones so dear,
And bring a “Little Bit Of Heaven” ever so near.
        `}</pre>
        )
    }
}

function poem3() {
    return {
        title: "Make Gentle This Moment", text: (
            <pre>{`
Humbly I stand and share your wonder,
It is your quiescent strength I ponder.
A sight of beauty at Nature’s hand,
You quietly grasp my soul to command.

On this still and peaceful night,
With no presence of mortals in sight,
Refresh my spirit with memories of old,
So many stories still yet untold. .

What magic is your grace and charm,
You have the power to even disarm
Unrested souls and make them calm
Those dark shadows do cause them harm.

Let the splendor remain before my eyes
As I turn from hardship, tears and sighs,
knowing always there is hope for me 
To glimpse once more sweet harmony.
`}</pre>
        )
    }
}

function poem4() {
    return {
        title: "Speak Softly Babbling Brook", text: (
            <pre>{`
You wander down the mountainside,
While years of secrets do you hide,
For many travelers have come your way
In solitude or frolicking play.
    
Bubbly waters chattering through,

Yet murmur you not tales false or true
Of lovers, or dreamers, or fools you knew,
Who passed or stopped there to renew.
    
Oh yes, speak softly babbling brook,
How wise and bounteous is your look,

Refreshing to all both day and night

Always remaining a wonderful sight. 
            
`}</pre>
        )
    }
}

function poem5() {
    return {
        title: "My Thirsting Spirit", text: (
            <pre>{`
I am like a leaf blowing in the wind
Drifting not always of my own accord
While My thirsting spirit wants to run
And feel new through streams yet to ford.
    
Distract me not from my senses
those sounds that are foreign to my soul
Let me walk through the forests of life
Never straying, nor betraying my goal.
    
I delight, dear world, in your silence
With sounds so pure and clear
As I turn from the noises that ache me
Hearing only the ones I hold dear.
    
I will travel far to find
The very essence of my being
Where nature sets for me a stage
With all its cues my spirit freeing.
`}</pre>
        )
    }
}

function poem6() {
    return {
        title: "Sky Of Courage", text: (
            <pre>{`
Make brave the sky to recall the night
That famous ride thru the bright moonlight
He met the task with tireless pride,
The patriot on whom we all relied.
    
The British arrived by sea that night
Alas! Two lanterns shed forth their light
With convictions strong and head unbowed,
His voice was heard by a country proud.
    
We gather now for those far and near
Brave daughters and sons not cowed by fear,
Who take the pledge and follow it through,
And march in step for the red, white, and blue.
    
Light up the sky, for that is our mark,
Despite the day be dreary or dark,
We the people both daring and free,
Still vowed to the torch of Liberty.
`}</pre>
        )
    }
}

function poem7() {
    return {
        title: "Tree Of Life", text: (
            <pre>{`
Within its boughs of beauty lies
The story of boundless love
That can only beget free will
Within the designs of its Creator.

The fruit from the Tree of Knowledge
brought forth another beginning
One with the presence of evil
Overshadowing the good.

To the woman who simply took a bite,
As we were told, and offered it to her mate,
Being lured by the Master of Temptation,
The gift of Life now needed transformation.

And so it was the Fruit of the Womb
The Savior born to the Mother of All
Who had to die on the tree of Life
Becoming the fruit of our redemption.

With love so great it was to undo
the first choice of fruit which lead to man's fall
and to then be granted a heavenly guest
Our Redeemer on this tree of salvation for all..
`}</pre>
        )
    }
}

function poem8() {
    return {
        title: "Temper The Waters", text: (
            <pre>{`
Whether a splatter or more intense,
The roaring tide with no plan or sense,
Water flows where it will go,
With no regard for friend or foe.

Be it a waterfall, river, or sea,
Or merely raindrops falling on me,
We all know well it runs its course
Without any pity or slight remorse.

Three quarters of the world does it possess,
Yet I can stand tall with my own finesse
To seize the moment and fashion my gait,
And find my place in the tides of fate.
`}</pre>
        )
    }
}


function poem9() {
    return {
        title: "Raindrops To Rainbows", text: (
            <pre>{`
Softly As The Rain Falls
Again You're Here With Me
To Share the Precious Moments
Still Fresh in My Memory.

I Hear the Pitter Patter
Against My Window Pain.
It Beats In Time With Silence
To Stir My Heart Again.

The Flicker Of The Candles
Casts Shadows On The Wall
And Lend Their Cherished Scents
To Days I Still Recall.

Softly Then The Rain Fell,
As Hand In Hand We Strolled
And Midst the Truth and Nonsense
Were The Words "I Love You" Told.

The Years Flew By And Were Well Spent
But Still We Lost Our Way
Our Smiles All Turned to Sadness,
So High A Cost To Pay.

And Yet My Heart Has No Remorse
For Days That Might Have Been.
As Through The Raindrops and The Storm, 
A Rainbow Shines Within.
`}</pre>
        )
    }
}

function poem10() {
    return {
        title: "My Heart Knows Best", text: (
            <pre>{`
The story of the rose is yet to be told, 
Its bloom of beauty is one to behold 
The lover's heart knows well the time, 
And hastens to make the moment sublime. 

For the flower that always brings a smile 
With fragrance and form to last a while, 
As the symbol of love to declare and express 
The height of all feeling and happiness. 

This is my wistful and earnest quest, 
To find the love my heart knows best. 
Be it for me then, Oh blossomy rose, 
From the finest of suitors to propose
`}</pre>
        )
    }
}


function getAllPoems() {
    return [
        poem1(), poem2(), poem3(), poem4(), poem5(), poem6(), poem7(), poem8(), poem9(), poem10()
    ]
}

export default getAllPoems;